<script lang="ts" setup></script>

<template>
    <RouterView />
</template>
